import React, { useEffect, useState } from "react";
import moment from "moment";
import { DEFAULT_FORMAT } from "../../../Components/utils/FootprintDatePicker";
import FootprintDatePicker from "../../../Components/utils/FootprintDatePicker";
import FootprintInputText from "../../../Components/utils/FootprintInputText";
import FootprintInputButton from "../../../Components/utils/FootprintInputButton";
import { useAtom } from "jotai";
import { activeChildDetail } from "../../../AtomStore/store";
import { useRequestProcessor } from "../../../requestProcessor";
import { handleTakeABreak } from "../../../QueryFunctions/queryfunction";
import SpinnerLoading from "../../../Components/utils/SpinnerLoading";
import { useNavigate } from "react-router-dom";

export const SERVER_DATE_FORMAT = "YYYY-MM-DD";

const TakeABreak = () => {
  const { useMutationWrapper } = useRequestProcessor();

  const [fromDate, setFromDate] = useState();
  const [endDate, setEndDate] = useState();
  const [error, setError] = useState("");
  const [reason, setReason] = useState("");
  const [activeChild] = useAtom(activeChildDetail);
  const navigate = useNavigate();

  useEffect(() => {
    console.log(
      "[Take a break] Initializing take a break form for child:",
      activeChild?.id
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const takeABreak = useMutationWrapper(
    ["takeABreak"],
    () => {
      console.log("[Take a break] Calling API: /parentapp/request ", {
        fromDate,
        endDate,
        reason,
      });
      return handleTakeABreak(fromDate, endDate, reason, navigate);
    },
    {
      onSuccess: (data) => {
        console.log("[Take a break] Take a break response:", data);
      },
    }
  );

  const validate = () => {
    if (!fromDate) {
      setError("Please Select Date");
      return false;
    } else if (!endDate) {
      setError("Please Select End Date");
      return false;
    } else if (!reason) {
      setError("Please Enter Reason");
      return false;
    }
    return true;
  };

  const submit = () => {
    if (validate()) {
      console.log("[Take a break] Submitting Form for take a break", {
        fromDate,
        endDate,
        reason,
      });
      takeABreak.mutate();
    }
  };

  const handleChange = (value) => {
    if (fromDate) setReason(value);
    else setError("Please Select Date First");
  };

  return (
    <div className="commonFeature mt-[20px]">
      {takeABreak.isLoading && <SpinnerLoading />}
      <div className="bg-white shadow rounded-lg ">
        <div className="p-2 pb-4  md:p-4">
          <form className="md:p-4">
            <div className="grid grid-cols-2 gap-0">
              {/* From Date */}
              <div className="flex flex-col border-r">
                <label
                  htmlFor="startDate"
                  className="text-[15px] font-medium mb-1 text-black"
                >
                  From
                </label>
                <div className="flex items-center py-1">
                  <FootprintDatePicker
                    minimumDate={fromDate ? fromDate : moment().add("days")}
                    onChange={(date) => setFromDate(moment(date))}
                    readOnly={true}
                    inputProps={{
                      placeholder: "Select Date",
                    }}
                  />
                  {/* <span className=" text-gray-500">
                    <i className="icon-calender text-black text-2xl" />
                  </span> */}
                </div>
              </div>

              {/* To Date */}
              <div className="flex flex-col">
                <label
                  htmlFor="endDate"
                  className="text-[15px] font-medium mb-1 text-black text-right"
                >
                  To (Last Day of Break)
                </label>
                <div className="flex items-center py-1 right-align">
                  {/* <span className=" text-gray-500">
                    <i className="icon-calender text-black text-2xl" />
                  </span> */}
                  {typeof fromDate === "undefined" ? (
                    // <div>
                    <FootprintDatePicker
                      disableCalendarOpen={true}
                      setSelectedDate={setFromDate}
                      minimumDate={fromDate}
                      onChange={(date) => {
                        setFromDate(moment(date));
                        setError(undefined);
                      }}
                      inputProps={{
                        onClick: (e) => {
                          e.preventDefault();
                          console.log("running jbdfjsdfjd");
                          setError("Please select a from date first.");
                        },
                        // disabled: true,
                        placeholder: "Select Date",
                        textAlign: "right",
                      }}
                      readOnly={true}
                      disabled={false}
                    />
                  ) : (
                    // </div>
                    <FootprintDatePicker
                      minimumDate={fromDate}
                      maximumDate={
                        new Date(fromDate).getTime() + 1000 * 60 * 60 * 24 * 89
                      }
                      onChange={(date) => {
                        setEndDate(moment(date));
                        setError(undefined);
                      }}
                      placeholder="End date"
                      inputProps={{
                        placeholder: "Select Date",
                        textAlign: "right",
                      }}
                      readOnly={true}
                    />
                  )}
                </div>
              </div>
            </div>
            <hr className=" mx-2 mt-2  bg-black" />
            {/* Reason */}
            <div className="mt-4">
              <FootprintInputText
                label="Reason"
                type="text"
                updateValue={fromDate !== undefined}
                defaultValue={reason}
                onChange={(value) => handleChange(value)}
                name="text"
              />
            </div>

            {/* Error Message */}
            {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

            {/* Submit Button */}
            <div className="flex justify-center mt-5">
              <FootprintInputButton
                style={{ color: "white" }}
                className="btn-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-md"
                onClick={() => submit()}
              >
                Submit
              </FootprintInputButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TakeABreak;
